import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || '/api',
    timeout: 30000,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('csform_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('csform_token');
            localStorage.removeItem('csform_admin');
            window.location.href = '/admin/login';
        }
        return Promise.reject(error);
    }
);

export default api;